import React from 'react';
import classnames from 'classnames';

import { is768Query } from '~/core/scripts/mediaquery-helper';
import Icon from '~/core/scripts/components/Icon';
import AreaDisplay from '~/kits/general/AreaDisplay';

import './Tooltip.styl';

const TOOLTIP_WIDTH = 250;

const Tooltip = props => {
  const { data, pos, isVisible, onClose, currentYear } = props;

  if (!data) {
    return null;
  }

  const style = is768Query() ? { left: `${pos.x + 15}px`, top: `${pos.y - 75}px` } : {};
  const isInverted = pos.x + 35 + TOOLTIP_WIDTH >= window.innerWidth;
  const tooltipClass = classnames('tooltip-wrapper', { 'is-active': isVisible, invert: isInverted });
  const currentData = data.data.find(d => d.year === currentYear);

  if (typeof currentData === 'undefined') {
    return null;
  }

  const isExtraMarker = currentData['Extra-Marker'] !== '';

  return (
    <div className={tooltipClass} style={{ ...style }}>
      <div className="tooltip">
        <button className="btn close" onMouseDown={onClose} onTouchEnd={onClose}>
          <Icon type="close" />
        </button>
        <AreaDisplay
          area={currentData}
          firstYear={data.firstYear}
          currentYear={currentYear}
          isExtraMarker={isExtraMarker}
        />
      </div>
    </div>
  );
};

export default Tooltip;
